import React from 'react';
import PropTypes from 'prop-types';
import { useConfigService } from '@thd-nucleus/experience-context';

import { PlpRecsRenderPlaceholder } from '../components/dynamic-recs/PlpRecsRenderPlaceholder';
import { BuyItAgain } from '../components/buyItAgain/buyItAgain';
import { useSearchContext, searchModelDataModel } from '../components/hooks/useSearchContext';

// Component name constants
const COMPONENT_NAMES = {
  BUY_IT_AGAIN: 'BuyItAgain',
  PLP_RECS_RENDER_PLACEHOLDER: 'PlpRecsRenderPlaceholder',
};

export const impPLPRecs = () => {
  return {
    id: '',
    component: 'DynamicRecs',
    type: 'product'
  };
};

export const PLPRecsComposable = (props) => {
  const { componentName } = props;
  const isBuyitagainEnabled = useConfigService('fs-prop:isBuyitagainEnabled') || false;

  const {
    isBrandPage,
    isBrowse,
    store,
    keyword,
    nValue,
    data,
    error,
    loading,
    itemIds,
    isCategoryPageFromMetadata
  } = useSearchContext();
  const impressionData = impPLPRecs();
  const filterBrowseRecs = useConfigService('fs:browseFilteredRecs') || false;

  if (componentName === COMPONENT_NAMES.BUY_IT_AGAIN && isBuyitagainEnabled && !isCategoryPageFromMetadata) {
    if (loading) {
      return null;
    }

    const parentFailed = error && (!data?.searchModel || data.searchModel === null);

    return (
      <div className="sui-grid sui-w-full sui-ml-2">
        <BuyItAgain
          nValue={nValue}
          schemaName="buyitagain"
          anchorId={`N-${nValue}`}
          loading={loading}
          data={data}
          error={error}
          zipCode={store?.zipCode}
          keyword={keyword}
          skipDataFetch={!parentFailed}
        />
      </div>
    );
  }

  if (componentName === COMPONENT_NAMES.PLP_RECS_RENDER_PLACEHOLDER && !loading && !isBrandPage) {
    return (
      <>
        <PlpRecsRenderPlaceholder
          requestKey="aGAQFG4j6QtVTSWqujfFYWeIU6BR5Mee"
          isBrowse={isBrowse}
          keyword={keyword}
          itemIds={itemIds}
          impressionData={impressionData}
          {...(filterBrowseRecs && { browseNValue: nValue })} // eslint-disable-line react/jsx-props-no-spreading
        />
      </>
    );
  }

  return null;
};

PLPRecsComposable.displayName = 'PLPRecsComposable';

PLPRecsComposable.defaultProps = {
  componentName: '',
};

PLPRecsComposable.propTypes = {
  componentName: PropTypes.string,
};

PLPRecsComposable.dataModel = searchModelDataModel;